import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { type FC } from "react";
import Row, { type SingleRowProps } from "./RowCollapsible";
import TableWithSkeleton from "./TableWithSkeleton";

interface RowsProps {
	rows: SingleRowProps[];
	titles: string[];
	isLoading: boolean;
}

const CollapsibleTable: FC<RowsProps> = ({ titles, rows, isLoading }) => {
	if (isLoading) {
		return <TableWithSkeleton />;
	}
	return (
		<TableContainer component={Box}>
			<Table aria-label="collapsible table">
				<TableHead>
					<TableRow>
						<TableCell />
						{titles.map((title) => (
							<TableCell key={title}>{title}</TableCell>
						))}
					</TableRow>
				</TableHead>
				<TableBody>
					{rows.map((row, index) => (
						<Row key={index} row={row} titles={titles} />
					))}
				</TableBody>
			</Table>
		</TableContainer>
	);
}

export default CollapsibleTable;
